// @ts-nocheck
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export type StatusColor = "success" | "warning" | "danger" | "info" | "neutral";

export const statusStyles = (color?: StatusColor, offset?: IconOffset) => {
    return css`
        display: flex;
        align-items: center;
        padding: ${pxToRem(7.5, 12)};
        border-radius: ${pxToRem(4)};

        ${({ theme }) => css`
            color: ${getColor(color)};
            background-color: ${getColor(`${color}.light`)};
            font-size: ${theme.design.typography.size.tiny};
            font-weight: ${theme.design.typography.weight.bold};
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        ${IconWrapper} {
            ${iconScalableStyles(pxToRem(20), offset)}
            overflow: visible;
            height: 0;
            margin: ${pxToRem(0, 7, 0, -1)};
        }
    `;
};
